import { render, staticRenderFns } from "./WxMoveConfig.vue?vue&type=template&id=278a89c7&scoped=true"
import script from "./WxMoveConfig.vue?vue&type=script&lang=js"
export * from "./WxMoveConfig.vue?vue&type=script&lang=js"
import style0 from "./WxMoveConfig.vue?vue&type=style&index=0&id=278a89c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a89c7",
  null
  
)

export default component.exports